import isDefined from './isDefined';

export default function (str) {
    return isDefined(str) &&
        str !== null &&
        typeof str === 'string' &&
        str !== '';
}